import React from 'react';
import { Container, Overlay, Content, IconWrapper, Title, Description, ButtonsContainer, OutlineButton, PrimaryButton } from './style';
import checkIcon from '../../assets/fashion/Actions/check.svg';

interface SuccessModalProps {
    isOpen: boolean;
    title: string;
    description: string;
    primaryButtonText: string;
    secondaryButtonText?: string;
    onPrimaryClick: () => void;
    onSecondaryClick?: () => void;
}

const SuccessModal: React.FC<SuccessModalProps> = ({
    isOpen,
    title,
    description,
    primaryButtonText,
    secondaryButtonText,
    onPrimaryClick,
    onSecondaryClick,
}) => {
    if (!isOpen) return null;

    return (
        <Overlay>
            <Container>
                <Content>
                    <IconWrapper>
                        <img src={checkIcon} alt="Sucesso" />
                    </IconWrapper>
                    <Title>{title}</Title>
                    <Description>{description}</Description>
                    <ButtonsContainer>
                        {secondaryButtonText && onSecondaryClick && (
                            <OutlineButton onClick={onSecondaryClick}>
                                {secondaryButtonText}
                            </OutlineButton>
                        )}
                        <PrimaryButton onClick={onPrimaryClick}>
                            {primaryButtonText}
                        </PrimaryButton>
                    </ButtonsContainer>
                </Content>
            </Container>
        </Overlay>
    );
};

export default SuccessModal;
